import { useToast } from "@/shared/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/shared/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        // If both title and description exist, combine them into one line
        const message = title && description
          ? `${title} ${description}`
          : title || description;

        return (
          <Toast key={id} {...props}>
            <div className="flex-1 flex items-center justify-center">
              {message && (
                <ToastDescription className="font-medium text-center">
                  {message}
                </ToastDescription>
              )}
            </div>
            {action}
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
